module.exports = __webpack_public_path__ + "img/Overview-icon.2ba0d1f8.svg";